import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import avtar2 from "../../../assests/emotions2.svg";
import { useNavigate } from "react-router-dom";
import logo from "../../../assests/Daalchini-logo.svg";
import Avtar from "../../../assests/Avatar.png";
import "./style.css";
import { Link } from "react-router-dom";
import SubMenu from "../Sidebar/SidebarItem";
import { SidebarData } from "./SidebarData";
import { useParams } from "react-router-dom";

export default function Sidebar(data, props) {
  let navigate = useNavigate();
  const { userid } = useParams();
  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);
  const [openKeys, setOpenKeys] = useState([""]);
  const [sidebar, setSidebar] = useState(false);

  const showSidebar = () => setSidebar(!sidebar);
  const Nav = styled.div`
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  `;

  const NavIcon = styled(Link)`
    margin-left: 2rem;
    font-size: 2rem;
    height: 80px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  `;

  const SidebarNav = styled.nav`
    margin-top: -80px;
    width: 250px;
    height: 60vh;
    display: flex;
    justify-content: center;
    margin:auto,
   
   
    left: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
    transition: 350ms;
    z-index: 10;
  `;

  const SidebarWrap = styled.div`
    width: 100%;
  `;

  // const logout = () => {
  //   console.log("hello");
  //   localStorage.removeItem("data");
  //   localStorage.removeItem("allPermissions");

  //   // history.push('/')
  //   navigate("/");
  // };
  const logout = () => {
    localStorage.removeItem("allPermissions");
    localStorage.removeItem("data");

    window.location.href = "/";
  };

  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

  const handleCloseDropdown = () => {
    setOpenDropdownIndex(null);
  };

  const viewProfile = () => {
    navigate(`/userlist/${195}`);
  };
  return (
    <>
      <div className="side-div1">
        <div className="sidebar">
          <div className="">
            <div className="logo-div">
              <img src={logo} alt="" />
            </div>
            <div className="main-profile">
              {/* <div className="profileDiv">
                <img src={Avtar} alt="" />
               {
                 <div className="designation">
                 <p style={{textTransform:"capitalize"}}>{localStorage.data ? JSON.parse(localStorage.data).details.userDetails.full_name : 'N/A'}</p>
                 <span>{localStorage.data ? JSON.parse(localStorage.data).details.userRole.role_name : 'N/A'}</span>
               </div>
               }
               
              
              </div> */}
              <div className="profileDiv">
                <img src={Avtar} alt="" />
                {localStorage.data && (
                  <div className="designation">
                    <p style={{ textTransform: "capitalize" }}>
                      {
                        JSON.parse(localStorage.data).details.userDetails
                          .full_name
                      }
                    </p>
                    <span>
                      {JSON.parse(localStorage.data).details.userRole.role_name}
                    </span>
                  
                  </div>
                )}
              </div>
              <div className="view-profile">
                <Link
                  to={`/users/userlist/${
                    localStorage.data
                      ? JSON.parse(localStorage.data).details.userDetails.id
                      : "N/A"
                  }`}
                >
                  <div
                    style={{ border: "0.1px solid #ccc", marginTop: "30px", }}
                  >
                    <button className="viewBtn">View Profile</button>
                  </div>
                </Link>
              </div>
            </div>
          </div>

          <div >
           
            {SidebarData.map((item) => (
              <SubMenu
                key={item.title}
                item={item}
                openDropdownIndex={openDropdownIndex}
                setOpenDropdownIndex={setOpenDropdownIndex}
                handleCloseDropdown={handleCloseDropdown}
              />
            ))}
          </div>
        </div>
        <div>
          <div className="logoutOutter">
            <Button
              style={{
                padding: "10px 48px",
                backgroundColor: "#fff",
                fontSize: "18px",
                color: "black",
              }}
              variant="outline-danger"
              size="lg"
              onClick={() => setShow(true)}
            >
              Logout
            </Button>
          </div>
        </div>

        <Modal
          className="logout-main"
          show={show}
          onHide={() => setShow(false)}
        >
          <div className="child-div">
            <div className="child-1">
              <img className="img-avtar" src={avtar2} alt="" />
            </div>

            <div className="child-2">
              <p>Log Out</p>
              <span>Are you sure want to Log Out ?</span>
            </div>
            <div className="logout-btn">
              <Button className="cancelBtn" onClick={handleClose}>
                Cancel
              </Button>
              <Button className="logoutBtn1" onClick={logout}>
                Yes, Logout
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
}

// import React, { useState, useEffect } from "react";
// import styled from "styled-components";
// import Button from "react-bootstrap/Button";
// import Modal from "react-bootstrap/Modal";
// import avtar2 from "../../../assests/emotions2.svg";
// import { useNavigate } from "react-router-dom";
// import logo from "../../../assests/Daalchini-logo.svg";
// import Avtar from "../../../assests/Avatar.png";
// import "./style.css";
// import { Link } from "react-router-dom";
// import SubMenu from "../Sidebar/SidebarItem";
// import { SidebarData } from "./SidebarData";
// import { useParams } from "react-router-dom";
// import { logoutuser } from "../../../HandleAPICalls/actions";

// export default function Sidebar(data, props) {
//   let navigate = useNavigate();
//   const { userid } = useParams();
//   const handleClose = () => setShow(false);
//   const [show, setShow] = useState(false);
//   const [openKeys, setOpenKeys] = useState([""]);
//   const [sidebar, setSidebar] = useState(false);

//   const showSidebar = () => setSidebar(!sidebar);
//   const Nav = styled.div`
//     height: 80px;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//   `;

//   const NavIcon = styled(Link)`
//     margin-left: 2rem;
//     font-size: 2rem;
//     height: 80px;
//     display: flex;
//     justify-content: flex-start;
//     align-items: center;
//   `;

//   const SidebarNav = styled.nav`
//     margin-top: -80px;
//     width: 250px;
//     height: 60vh;
//     display: flex;
//     justify-content: center;
//     margin: auto,
   
//     left: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
//     transition: 350ms;
//     z-index: 10;
//   `;

//   const SidebarWrap = styled.div`
//     width: 100%;
//   `;

//   const logout = () => {
//     localStorage.removeItem("allPermissions");
//     localStorage.removeItem("data");
//     window.location.href = "/";
//   };

//   const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

//   const handleCloseDropdown = () => {
//     setOpenDropdownIndex(null);
//   };

//   const viewProfile = () => {
//     navigate(`/userlist/${195}`);
//   };

//   const getUserRole = () => {
//     const data = JSON.parse(localStorage.getItem("data"));
//     return data ? data.details.userRole.role_id : null;
//   };

//   const filterSidebarData = (role) => {
//     const filterSubMenu = (item, allowedSubMenus) => {
//       if (item.subNav && item.subNav.length > 0) {
//         item.subNav = item.subNav.filter((subItem) =>
          
//           allowedSubMenus.includes(subItem.title),
          
//         );
        
//       }
//       return item;
//     };
  
//     if (role === 1) {
//       return SidebarData; 
//     } else if (role === 4) {
//       return SidebarData.filter((item) =>
//         ["Dashboard","Configuration" ].includes(item.title)
//       ).map((item) => filterSubMenu(item, ["Orders", "Brand Categorization"])); 
//     } else if (role === 11) {
//       return SidebarData.filter((item) =>
//         ["Dashboard", "Configuration"].includes(item.title)
//       ).map((item) => filterSubMenu(item, ["Submenu3"]));
//     } else if (role === 2) {
//       return SidebarData.filter((item) =>
//         ["Dashboard", "Add Center", "Wallets and Tags"].includes(item.title)
//       ).map((item) => filterSubMenu(item, ["Submenu4", "Submenu5"]));
//     } else if (role === 3) {
//       return SidebarData.filter((item) =>
//         ["Dashboard", "Customer Manager", "Configuration"].includes(item.title)
//       ).map((item) => filterSubMenu(item, ["Submenu6", "Submenu7"]));
//     } else if (role === 5) {
//       return SidebarData.filter((item) =>
//         ["Dashboard", "Configuration", "Add Center"].includes(item.title)
//       ).map((item) => filterSubMenu(item, ["Submenu8"]));
//     } else if (role === 6) {
//       return SidebarData.filter((item) =>
//         ["Configuration","Users and Roles" ].includes(item.title)
//       ).map((item) => filterSubMenu(item, ["Vending machines", "Cohorts","Manage Partners"]));
//     }   else if (role === 7) {
//       return SidebarData.filter((item) =>
//         ["Configuration"].includes(item.title)
//       ).map((item) => filterSubMenu(item, ["Submenu9", "Submenu10"]));
//     }
  
   
//     return [];
//   };
  


//   // const filterSidebarData = (role) => {
//   //   switch (role) {
//   //     case 1:
//   //       return SidebarData;
//   //     case 2:
//   //       return SidebarData.filter((item) =>
//   //         ["Dashboard", "Add Center", "Wallets and Tags"].includes(item.title)
//   //       );
//   //     case 3:
//   //       return SidebarData.filter((item) =>
//   //         ["Dashboard", "Customer Manager", "Configuration"].includes(
//   //           item.title
//   //         )
//   //       );
//   //     case 4:
//   //       return SidebarData.filter((item) =>
//   //         ["Dashboard", "Users and Roles"].includes(item.title)
//   //       );
//   //     case 5:
//   //       return SidebarData.filter((item) =>
//   //         ["Dashboard", "Configuration", "Add Center"].includes(item.title)
//   //       );
//   //     case 6:
//   //       return SidebarData.filter((item) =>
//   //         ["Dashboard", "Customer Manager", "Wallets and Tags"].includes(
//   //           item.title
//   //         )
//   //       );
      
//   //     default:
//   //       return [];
//   //   }
//   // };


//   const userRole = getUserRole();
//   const filteredSidebarData = filterSidebarData(userRole);

//   return (
//     <>
//       <div className="side-div1">
//         <div className="sidebar">
//           <div className="">
//             <div className="logo-div">
//               <img src={logo} alt="" />
//             </div>
//             <div className="main-profile">
//               <div className="profileDiv">
//                 <img src={Avtar} alt="" />
//                 {localStorage.data && (
//                   <div className="designation">
//                     <p style={{ textTransform: "capitalize" }}>
//                       {
//                         JSON.parse(localStorage.data).details.userDetails
//                           .full_name
//                       }
//                     </p>
//                     <span>
//                       {JSON.parse(localStorage.data).details.userRole.role_name}
//                     </span>
//                   </div>
//                 )}
//               </div>
//               <div className="view-profile">
//                 <Link
//                   to={`/users/userlist/${
//                     localStorage.data
//                       ? JSON.parse(localStorage.data).details.userDetails.id
//                       : "N/A"
//                   }`}
//                 >
//                   <div
//                     style={{ border: "0.1px solid #ccc", marginTop: "30px" , width:"13vw"}}
//                   >
//                     <button className="viewBtn">View Profile</button>
//                   </div>
//                 </Link>
//               </div>
//             </div>
//           </div>

//           <div >
//             {filteredSidebarData.map((item) => (
//               <SubMenu
//                 key={item.title}
//                 item={item}
//                 openDropdownIndex={openDropdownIndex}
//                 setOpenDropdownIndex={setOpenDropdownIndex}
//                 handleCloseDropdown={handleCloseDropdown}
//               />
//             ))}
//           </div>
//         </div>
//         <div>
//           <div className="logoutOutter">
//             <Button
//               style={{
//                 padding: "10px 48px",
//                 backgroundColor: "#fff",
//                 fontSize: "18px",
//                 color: "black",
//               }}
//               variant="outline-danger"
//               size="lg"
//               onClick={() => setShow(true)}
//             >
//               Logout
//             </Button>
//           </div>
//         </div>

//         <Modal
//           className="logout-main"
//           show={show}
//           onHide={() => setShow(false)}
//         >
//           <div className="child-div">
//             <div className="child-1">
//               <img className="img-avtar" src={avtar2} alt="" />
//             </div>

//             <div className="child-2">
//               <p>Log Out</p>
//               <span>Are you sure want to Log Out ?</span>
//             </div>
//             <div className="logout-btn">
//               <Button className="cancelBtn" onClick={handleClose}>
//                 Cancel
//               </Button>
//               <Button className="logoutBtn1" onClick={logout}>
//                 Yes, Logout
//               </Button>
//             </div>
//           </div>
//         </Modal>
//       </div>
//     </>
//   );
// }

